;(function() {
  'use strict'

  Controller.$inject = ["$log", "$scope", "$state", "$stateParams", "app", "glDialog", "glError", "elementService", "shareService", "userService", "messageService"];
  angular.module('app.element').controller('Element', Controller)

  // --------------------

  /* @ngInject */
  function Controller(
    $log,
    $scope,
    $state,
    $stateParams,
    app,
    glDialog,
    glError,
    elementService,
    shareService,
    userService,
    messageService
  ) {
    var log = $log.create('Element')

    $scope.data = {}
    $scope.isOwner = elementService.isOwner
    $scope.sendMessage = sendMessage
    $scope.claimElement = claimElement
    $scope.share = shareService.share
    $scope.isSurveys = isSurveys // todo: move to service
    $scope.shouldShowSurvey = shouldShowSurvey // todo: move to service

    elementService.get($stateParams.id).then(onElement, onElementError)

    function onElement(element) {
      $scope.$watch('data.imageData', onImage, true)
      $scope.element = element
      if ($stateParams.id === 'source') {
        updateUrl()
      }
      app.setTitle(element.extras.title)
    }

    function onElementError() {
      log.error('error fetching element (id: ' + $stateParams.id + ')')
      glError.notFound()
    }

    function updateUrl() {
      $state.go(
        $state.current.name,
        { id: $scope.element.id },
        {
          location: 'replace',
          notify: true,
          reload: false,
        }
      )
    }

    function sendMessage() {
      messageService.showSendDialog({
        elementId: $scope.element.id,
        imageData: $scope.data.imageData,
        moodEntry: $scope.data.mood,
      })

      $scope.data.imageData = null // reset imageData
    }

    function isSurveys() {
      if (!$scope.element) {
        return
      }
      var surveys = $scope.element.extras.surveys
      var found = false
      _.each(surveys, function(survey) {
        if (shouldShowSurvey(survey)) {
          found = true
        }
      })
      return found
    }

    function shouldShowSurvey(survey) {
      if (survey.isPromoted === true) {
        return true
      }
      // } else if (
      //      followService.isFollowing($scope.element.id) === true &&
      //      surveysService.fromCache(survey.id)
      // ) {
      //     return true;
      // }
    }

    function onImage(imageData) {
      if (imageData) {
        sendMessage()
      }
    }

    function claimElement() {
      if (!$scope.app.user.id) {
        userService
          .promptLogin(
            'You need to log in or sign up to Glow to be able to claim your business.'
          )
          .then(showClaim)
      } else {
        showClaim()
      }

      function showClaim() {
        glDialog.show({
          templateUrl: 'element-claim-dialog.template.html',
          controller: function() {},
          locals: {
            element: $scope.element,
          },
        })
      }
    }
  }
})()
